import { RowValue } from '../ExecutiveSummaryGenericTable/types';

export const BLANK_CELL: { fixed: RowValue } = { fixed: { value: '' } };
export const BLANK_PERCENTAGE_CELL: { fixed: RowValue } = { fixed: { value: '', format: 'percentage' } };

/** A column a row has no figure for at all - project profit is reported at sale only. */
export const DASH_CELL: { fixed: RowValue } = { fixed: { value: '-', format: 'none' } };
